(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "55f4db2a18add3bcbf335f0b13648b5ae2b15e0e"
};